export enum AlertType {
  NEUTRAL = "neutral",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}
